var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about bg-light"},[_c('top'),_c('lead'),_c('applink'),_c('features'),_c('applink'),_c('updates'),_c('bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }